<div class="header-bar">
  <h1>Upload Orders</h1>
</div>
<div class="content-container">
  <section class="card">
    <div class="col-12 xl:col-12 lg:col-12" *ngIf="showOrderLimits">
      <order-limits-calendar></order-limits-calendar>
    </div>
    <div class="col-12 xl:col-12 lg:col-12">
      <p-steps
        [model]="items"
        [(activeIndex)]="activeIndex"
        [readonly]="false"
        styleClass=""
      ></p-steps>
    </div>

    <div *ngIf="activeIndex == 0">
      <p-panel [style]="{ 'margin-bottom': '20px' }">
        <p-header>
          <div ngClass="">
            <a
              [href]="
                isImpersonating ? sample_spreadsheet_impersonating_file : sample_spreadsheet_file
              "
              download=""
              type="button "
              pButton
              icon="fa fa-download"
              label="Sample Spreadsheet"
              class=""
            ></a>
          </div>
        </p-header>
        <div [ngStyle]="{ 'overflow-y': 'auto' }">
          <img src="assets/images/spreadsheet_import_sample.png" />
        </div>
      </p-panel>

      <div class="col-12 xl:col-12 lg:col-12">
        <data-import [importDataType]="4"></data-import>
      </div>

      <br />
    </div>
    <div *ngIf="activeIndex == 1">
      <order-validate></order-validate>
    </div>
    <div *ngIf="activeIndex == 2">
      <order-completed></order-completed>
    </div>
  </section>
</div>
